import {
  BasicInstance,
  ConnectorInstance,
  Datapoint,
  DefaultDatapointTypes,
  WindowMessageDatapoint,
  WindowMessageEnvelope
} from '@olive/oli-types';
import ConnectivityHolder from '../ConnectivityHolder';
import ConnectivityManager from '../ConnectivityManager';
import AbstractDispatcher from './AbstractDispatcher';

export default class WindowDispatcher extends AbstractDispatcher {
  connectivityManager: ConnectivityManager;
  origins: {
    [origin: string]: {
      origin: string,
      win: MessageEventSource
    }
  }

  constructor(
    connectivityHolder: ConnectivityHolder,
    connectivityManager: ConnectivityManager
  ) {
    super(connectivityHolder);
    this.connectivityManager = connectivityManager;
    this.origins = {};
    window.addEventListener('message', this.#onMessage.bind(this));
  }

  async #onMessage(message: MessageEvent) {
    console.log('#onMessage', message);
    const envelope = message.data as WindowMessageEnvelope;

    if (this.#isRegisterOriginMessage(envelope)) {
      this.#registerOriginMessage(message);
      return;
    }

    console.log('event to dispatch', envelope);

    const allConnectivitys = this.connectivityHolder.getAll();
    if (!allConnectivitys) {
      return;
    }
    const connectors = Object.keys(allConnectivitys).map(key => allConnectivitys[key]).filter(connectivity => connectivity.type === 'connectorInstance');


    const matchingConnectors = connectors.filter(connector => {
      const connectorInstance = connector as ConnectorInstance;
      //@ts-ignore broadcast temporary problems
      return envelope.datapointID && connectorInstance.datapoints?.[0] && (connectorInstance.datapoints?.[0] as BasicInstance)?.id === envelope.datapointID;
    });
    console.log('matchingConnectors', matchingConnectors);

    const dispatchers = matchingConnectors.map(connector => this.connectivityManager.invoke({
      id: connector.instanceID || connector.instanceOf,
      input: envelope.payload
    }));
    const result = await Promise.all(dispatchers);
    console.log('dispatched: ', result);
  }

  #isRegisterOriginMessage(envelope: WindowMessageEnvelope)
  {
    return envelope.topic === 'oliveRegisterOrigin';
  }

  #registerOriginMessage(message: MessageEvent) {
    console.info('registering new window origin');
    const envelope = message.data as WindowMessageEnvelope;
    const payload = envelope.payload as unknown as {id: string, origin: string};
    if(payload.origin && payload.id)
    {
      this.origins[payload.id] = {
        origin: payload.origin,
        win: message.source
      }
    }
    else {
      console.error('Missing origin or window in register origin message: ', payload);
    }
  }

  #getDatapoint(id: string | undefined | null): Datapoint | null {
    if (!id) {
      return null;
    }
    return this.connectivityHolder.get(id) as Datapoint;
  }

  canDispatch(props: { id: string, datapoint: Datapoint | undefined }): boolean {
    const datapoint = !props.datapoint ? this.#getDatapoint(props.id) : props.datapoint;
    if (!datapoint) {
      return false;
    }
    const type = datapoint.datapoint.type;
    return type === DefaultDatapointTypes.WINDOW_MESSAGE;
  }

  async dispatch(props: { id: string; input?: object }) {

    const datapoint = this.#getDatapoint(props.id) as WindowMessageDatapoint;
    if (!datapoint) {
      console.warn('Datapoint not found: ' + props.id);
      return null;
    }
    const windowMessage = datapoint.datapoint.windowmessage;

    const origin = windowMessage.origin;
    const originEntry = this.origins[origin];
    if (!originEntry) {
      console.error('Tried to dispatch message to unknown origin: ' + origin);
    }

    const topic = windowMessage.topic;

    const envelope = {
      topic,
      payload: {...windowMessage.payload, ...props.input}
    };

    //@ts-ignore
    originEntry.win.postMessage(envelope, originEntry.origin);



    return props.input;
  }

}